"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M42.2 430.4V208.3h104.2v222.1H42.2zm341.3-237.1c30.3-2.1 58.4 16.1 68.8 44.6 20.6 49.5-14.1 169.2-15.6 174.3l-.9 2.4c-8.6 20.4-27.5 34.6-49.5 37.1-18.5 2.3-37.1 3.4-55.7 3.2-27 .8-50.9-1.8-81.1-8.2-30.2-6.5-46.9-14.1-61.4-17.7V208.1c15.2-9.8 26.1-18.6 36.5-33.4 17.2-29 31.3-59.7 42-91.6 2.8-18.4 9-41.4 29.2-41.4 23.8-.3 43.5 18.3 44.8 42 1.5 8 2.1 16.1 2.1 24.2-.5 30-8.4 59.3-23.1 85.5h63.9z"
  });
};

exports.default = _default;